import React from 'react';
import { Text } from '@doda/io-react/common';
import { JobDRImageResponse } from '@doda/api-client/aspida/@types';
import Image from 'next/image';
import styles from './index.module.scss';

const NO_IMAGE_PATH = '/assets/image/img_R60_D_190_01_job03.gif';

/**
 * DrImage Props
 */
interface DrImagesProps {
  drImageList: JobDRImageResponse[];
  jid: string;
}
/** T原稿 Dr求人 画像(最大5個) */
export const DrImages: React.FC<DrImagesProps> = ({ drImageList, jid }) => {
  return (
    <div className={styles['jobSearchDetail-drImages']}>
      {drImageList.map(({ index, imageId, caption }) => (
        <div key={index} className={styles['jobSearchDetail-drImages__item']}>
          <div className={styles['jobSearchDetail-drImages__imageContainer']}>
            {imageId && jid ? (
              <img
                className={styles['jobSearchDetail-drImages__image']}
                src={`/DodaCommon/View/DrImageDisplay.action?imgid=${imageId}&jid=${jid}`}
                alt=""
              />
            ) : (
              <Image width={240} height={160} src={NO_IMAGE_PATH} alt="" />
            )}
          </div>
          {caption && (
            <Text size="12" style={{ marginTop: '8px' }}>
              {caption}
            </Text>
          )}
        </div>
      ))}
    </div>
  );
};
